var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckboxDefault = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 15,
  viewBox: "0 0 15 15",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 807.5,
  y: 496.5,
  width: 14,
  height: 14,
  rx: 3,
  transform: "translate(-807 -496)",
  stroke: "#5ACCE6",
  fillRule: "evenodd"
})));
export { SvgCheckboxDefault as ReactComponent };
export default __webpack_public_path__ + "assets/images/checkbox-default.svg";